<template>
  <div
    :class="[
      'faq',
      `variant-${variant}`,
    ]"
  >
    <div
      :class="[
        'faq__summary',
        `variant-${variant}`,
      ]"
      @click="onClick"
    >
      <slot name="header"></slot>
      <div
        :class="[
          'faq__toggler',
          `variant-${variant}`,
        ]"
      />
    </div>
    <div class="faq__body">
      <slot name="main"></slot>
    </div>
  </div>
</template>

<script>

const VARIANTS = {
  LIGHT_SQUARED: 'light-squared',
  DARK: 'dark',
  LIGHT_ROUNDED: 'light-rounded',
};
export default {
  name: 'FAQBar',
  props: {
    variant: {
      type: String,
      default: VARIANTS.LIGHT_SQUARED,
      validator(value) {
        return Object.values(VARIANTS).includes(value);
      },
    },
  },
  methods: {
    onClick({ currentTarget }) {
      currentTarget.lastChild.classList.toggle('faq__toggler_open');
      currentTarget.classList.toggle('faq__summary_open');
      const body = currentTarget.nextElementSibling;

      body.style.maxHeight = body.style.maxHeight ? '' : `${body.scrollHeight + 16}px`;
    },
  },
};
</script>
